export default __webpack_public_path__ + "static/media/element_spec_63.23ebc74b.jpg";